import { Component, OnInit } from '@angular/core';
import { Product } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-uig-product-price-search-tab',
    templateUrl: './uig-product-price-search-tab.component.html',
    styleUrls: ['./uig-product-price-search-tab.component.scss'],
    standalone: false
})
export class UigProductPriceSearchTabComponent implements OnInit {

  product$: Observable<Product>;

  constructor(protected currentProductService: CurrentProductService) { }

  ngOnInit(): void {
    this.product$ = this.currentProductService.getProduct();
  }

}
